module.exports = __webpack_public_path__ + "img/xukui-20190127-1-1-500x500.747aa518.jpg";